import { Component } from '@angular/core';
import { AlarmTableRowComponent } from '../alarm-table-row/alarm-table-row.component';

@Component({
    selector: 'app-alarm-table-row-compact',
    templateUrl: './alarm-table-row-compact.component.html',
    styleUrls: [
        './alarm-table-row-compact.component.scss',
        '../alarm-table-row/alarm-table-row.component.scss',
    ],
    standalone: false
})
export class AlarmTableRowCompactComponent extends AlarmTableRowComponent {}
